import React from 'react'

import { Autocomplete, TextField } from '@mui/material'
import { formField } from 'decorators'

type Option = { value: any; label: string }

type FormSearchSelectProps = {
  field: { input: any; meta: any }
  label?: string
  options?: Option[]
  disabled?: boolean
}

// Single-select with a type-ahead search box, for long option lists (e.g. countries).
const FormSearchSelect = ({ field, label = '', options = [], disabled }: FormSearchSelectProps) => {
  const { input, meta } = field
  const selected = options.find(option => option.value === input.value) ?? null
  const error = meta.touched ? meta.error : undefined

  return (
    <Autocomplete
      disableClearable
      disabled={disabled}
      fullWidth
      getOptionLabel={option => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onBlur={input.onBlur}
      onChange={(_e, option) => input.onChange(option ? option.value : '')}
      options={options}
      renderInput={params => <TextField {...params} error={!!error} helperText={error} label={label} />}
      value={selected as Option}
    />
  )
}

export default formField(FormSearchSelect)
